// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"482":"charts","824":"portfolio"}[chunkId] || chunkId) + "." + {"74":"fbf23cc5","134":"955c284f","180":"e4da614e","329":"f6c2ef21","479":"5052ad5c","482":"c2f84075","550":"e9e60f59","761":"78239dc7","819":"22f889a8","824":"56ea3221","904":"42e5e41f","927":"8b17cc39","951":"70a52edd","993":"dc433e41"}[chunkId] + ".js";
};